import { type ChangeHistory, selectUnsavedCachedViews, useAppSelector } from '@salescore/client-redux'
import { logger } from '@salescore/frontend-common'
import { useCallback, useEffect } from 'react'

export const useStopUnload = ({
  parentViewProtectingUnload,
  changes,
  kpiFormModified,
  onChangesChange,
  hasChangeToKpiPivotParameter,
  hasChangeToViewSchema,
}: {
  parentViewProtectingUnload: boolean
  changes: ChangeHistory[]
  kpiFormModified: boolean
  onChangesChange?: (hasChange: boolean) => void
  hasChangeToKpiPivotParameter: boolean
  hasChangeToViewSchema: boolean
}): void => {
  const unsavedCachedViews = useAppSelector(selectUnsavedCachedViews)
  const stopUnload = useCallback((event: BeforeUnloadEvent) => {
    logger.debug(`stopUnload called`)
    event.preventDefault()
  }, [])

  useEffect(() => {
    if (parentViewProtectingUnload) {
      return
    }
    const hasChangesToCurrentTab =
      changes.length > 0 || kpiFormModified || hasChangeToViewSchema || hasChangeToKpiPivotParameter

    if (hasChangesToCurrentTab || unsavedCachedViews.length > 0) {
      window.addEventListener('beforeunload', stopUnload)
      if (hasChangesToCurrentTab && onChangesChange !== undefined) {
        onChangesChange(true)
      }
    } else {
      window.removeEventListener('beforeunload', stopUnload)
      if (onChangesChange !== undefined) {
        onChangesChange(false)
      }
    }
    return () => {
      window.removeEventListener('beforeunload', stopUnload)
      if (onChangesChange !== undefined) {
        onChangesChange(false)
      }
    }
  }, [
    kpiFormModified,
    hasChangeToViewSchema,
    hasChangeToKpiPivotParameter,
    changes.length,
    unsavedCachedViews.length,
    stopUnload,
    parentViewProtectingUnload,
  ])
}
